import MimeType from 'assets/utils/file/mimeType/MimeType';

type Props = {
  blob: Blob;
  name: string;
  type?: MimeType;
};
export function createFileFromBlob({ blob, name, type }: Props): File {
  return new File([blob], name, { type: type ?? blob.type });
}
